<template>
    <div class="doctor-qrcode-panel">
        <div class="contain">
            <div class="content">
                <div class="top">
                    <div class="info">
                        <div class="img">
                            <img :src="record.doctorImg" alt="" />
                        </div>
                        <div class="info-detail">
                            <div class="title">
                                <span class="name">
                                    {{ record.doctorName }}
                                </span>
                                <span class="tag">
                                    {{ record.doctorTitle }}
                                </span>
                            </div>
                            <div class="explain">收到一面锦旗</div>
                        </div>
                    </div>
                    <div class="pennant">
                        <img class="imgpennant" :src="record.imgUrl" alt="" />
                        <div class="notice">
                            <div>“{{ record.content }}”</div>
                            <div>电子锦旗</div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="notice">
                        <div>长按识别关注二维码</div>
                        <div>有问题就找TA</div>
                    </div>
                    <div class="qrcode">
                        <img :src="record.doctorQrcode" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div class="gift-date">
            <div>—— {{record.patientName?record.patientName.replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g , '$1**'):""}} 赠</div>
            <div>{{ record.createDate|formatDate('yyyy-MM-dd') }}</div>
        </div>
    </div>
</template>

<script>
import doctorService from '../../services/doctor';
export default {
    name: 'doctorQrcode',
    data() {
        return {
            record: {},
        };
    },
    computed: {},
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            doctorService
                .presentContent(this.$route.query.id)
                .then((res) => {
                    this.record = res.data.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style lang="less">
.doctor-qrcode-panel {
    height: 100vh;
    position: relative;
    background: #3c4c69 url('http://ooso.oss-cn-hangzhou.aliyuncs.com/eb2f0040-2a8f-11ee-b8f9-a7e1d473d0df.png') no-repeat;
    background-size: 100% 100%;

    .contain {
        position: absolute;
        width: 332px;
        height: 488px;
        background: linear-gradient(
            135deg,
            #ff9b48 0%,
            #ffdbbd 35%,
            #eed2bb 71%,
            #efb381 100%
        );
        top: 26px;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        padding: 7px 8px;
        .content {
            background: white;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        .top {
            height: 359px;
            // border-bottom: 1px solid #e5e5e5;
        }
        .bottom {
            flex: 1;
        }
    }
    .gift-date {
        position: absolute;
        bottom: 90px;
        right: 30px;
        text-align: right;
        color: #ffffff;
        & > div:first-child {
            margin-bottom: 3px;
        }
    }
    .info {
        display: flex;
        padding: 20px 30px;
        .img {
            width: 68px;
            height: 68px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 15px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .info-detail {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .title {
                display: flex;
                align-items: center;
                .name {
                    font-weight: bold;
                    font-size: 20px;
                    color: #1a1a1a;
                    margin-right: 10px;
                }
                .tag {
                    padding: 3px 5px;
                    color: #ffffff;
                    background: #18a370;
                    border-radius: 4px;
                    // font-weight: bold;
                }
            }
            .explain {
                color: #595959;
            }
        }
    }
    .pennant {
        padding-top: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .imgpennant{
          width: 90%;
        }
        .notice {
            max-width: 250px;
            text-align: center;
            color: #3a4966;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 10px;
            & > div {
                margin-bottom: 10px;
            }
        }
    }
    .bottom {
        display: flex;
        justify-content: right;
        margin-right: 20px;
        align-items: center;
        margin-top: 40px;
        .qrcode img {
            width: 52px;
            height: 52px;
            margin-left: 10px;
        }
        .notice {
            text-align: right;
            & > div {
                color: #646464;
                margin-bottom: 8px;
            }
        }
    }
}
</style>
